module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_0@3x.14b1e80f.png";